import { useCallback, useRef, useState } from 'react';
import { Autocomplete, useJsApiLoader } from '@react-google-maps/api';
import { TCountryCode } from 'countries-list';
import { googleConfig } from './Map';
import UI from '../ui';

// TODO: Temporarily using Google Places since Expedia and other API stores require being an affiliate
type autocomplete = google.maps.places.Autocomplete;
export type place = google.maps.places.PlaceResult;

type props = {
  country?: TCountryCode
  onSelectedHotel: (place: place) => void
  placeHodler?: string
  clearOnSelect?: boolean
};
const HotelSearch: React.FC<props> = ({ country, onSelectedHotel, placeHodler, clearOnSelect = true }) => {
  const { isLoaded } = useJsApiLoader(googleConfig);
  const [autocomplete, setAutocomplete] = useState<autocomplete | null>(null);
  const [value, setValue] = useState('');

  const inputRef = useRef(null);

  const onPlaceChanged = useCallback(() => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      onSelectedHotel(place);
      if (clearOnSelect) {
        setValue('');
      }
      else if (place.name) {
        setValue(place.name);
      }
    }
  }, [autocomplete, clearOnSelect, onSelectedHotel]);

  return isLoaded
    ? (
        <Autocomplete
          onLoad={setAutocomplete}
          onPlaceChanged={onPlaceChanged}
          options={{
            types: ['lodging'], // Restrict search to hotels
            componentRestrictions: country ? { country } : undefined, // Restrict to country
          }}
        >
          <UI.Textfield
            ref={inputRef}
            placeHolder={placeHodler || 'Search for hotels'}
            fullWidth
            value={value}
            onChange={setValue}
            startIcon="hotel"
          />
        </Autocomplete>
      )
    : <></>;
};

export default HotelSearch;
